(function(){
  function boot(){
    var progress=document.createElement('div');
    progress.id='ego-scroll-progress';
    document.body.appendChild(progress);
    function onScroll(){
      var max=document.documentElement.scrollHeight-window.innerHeight;
      var ratio=max>0?window.scrollY/max:0;
      progress.style.transform='scaleX('+Math.max(0,Math.min(1,ratio))+')';
      document.body.classList.toggle('ego-has-scrolled',window.scrollY>24);
    }
    onScroll();window.addEventListener('scroll',onScroll,{passive:true});
    var items=document.querySelectorAll('[data-ego-reveal]');
    if(!('IntersectionObserver' in window)){items.forEach(function(x){x.classList.add('is-visible')});return;}
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12,rootMargin:'0px 0px -5%'});
    items.forEach(function(item){observer.observe(item)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
